export enum DataHooks {
  DailyLayout = 'daily-layout',
}
